export default {
    methods:{
        userRoleFind: function(idrole){
            // return this.user_role.find(dat =>{
            //         return dat.id === idrole
            //     })
            const tmp = this.user_role.find(dat =>{
                return dat.id === idrole
            })
            return typeof tmp !== 'undefined' ? true : false
        }
    },



}